import React from "react";
import AdminSidebar from "./AdminSidebar";
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
    return (
        <div style={{ display: 'flex' }}>
            <AdminSidebar />
            <div>
                <Outlet />
            </div>
        </div>
    );
};

export default AdminLayout;